export default __webpack_public_path__ + "static/media/linkedin.4e0e5fb9.png";